module.exports = __webpack_public_path__ + "img/e-invoice-qrcode.de1bf9f7.png";